/**
 * Per-user UI session keys in localStorage.
 *
 * These survive refresh / browser close for the same user, but must be cleared
 * on logout and when the authenticated identity changes so one user's Results
 * tabs and file-manager path cannot leak to another.
 */

export const VIEWER_SESSION_STORAGE_KEYS = [
  'grid-viewer-state',
  'grid-viewer-state-echart',
  'grid-viewer-state-pathway',
  'grid-viewer-state-workflow',
  // Legacy keys from ViewerManager (kept so old data cannot leak after a switch)
  'viewer-state',
  'viewer-state-echart',
  'viewer-state-pathway',
  'viewer-state-workflow',
  'results-viewer-order',
] as const

export const FILE_TABLE_SESSION_STORAGE_KEYS = [
  'fileTable-folderPath',
  'fileTable-sorting',
  // My Files, the Shared virtual folder, or a shared folder (see components/fileBrowserLocation.ts).
  'fileTable-root',
] as const

const USER_SESSION_STORAGE_KEYS = [
  ...VIEWER_SESSION_STORAGE_KEYS,
  ...FILE_TABLE_SESSION_STORAGE_KEYS,
] as const

function removeKeys(keys: readonly string[]): void {
  for (const key of keys) {
    try {
      localStorage.removeItem(key)
    } catch {
      // ignore quota / access errors during cleanup
    }
  }
}

/** Clears Results/Workflows open viewers and the last Files location (root and folder). */
export function clearUserSessionLocalStorage(): void {
  removeKeys(USER_SESSION_STORAGE_KEYS)
}
